import '../assets/NcFormGroup-CUFSO_ru.css';
import { defineComponent, useSlots } from "vue";
import { c as createElementId } from "./createElementId-DhjFt1I9.mjs";
import { n as normalizeComponent } from "./_plugin-vue2_normalizer-DU4iP6Vu.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NcFormGroup",
  props: {
    label: { default: void 0 },
    description: { default: void 0 },
    hideLabel: { type: Boolean, default: false },
    hideDescription: { type: Boolean, default: false },
    noGap: { type: Boolean, default: false }
  },
  setup(__props) {
    const props = __props;
    const slots = useSlots();
    const id = `nc-form-group-${createElementId()}`;
    const descriptionId = `${id}-description`;
    const hasDescription = () => !!props.description || !!slots.description;
    const getDescriptionId = () => hasDescription() ? descriptionId : void 0;
    const hasContentOnly = () => props.hideLabel && (!hasDescription() || props.hideDescription);
    return { __sfc: true, props, slots, id, descriptionId, hasDescription, getDescriptionId, hasContentOnly };
  }
});
const formGroup = "_formGroup_NuzaL";
const formGroup_noGap = "_formGroup_noGap_MqFm0";
const formGroup__label = "_formGroup__label_5SyuR";
const formGroup__description = "_formGroup__description_ECa4x";
const formGroup__content = "_formGroup__content_JkqhS";
const formGroup__content_only = "_formGroup__content_only_Ri6Q-";
const style0 = {
  "material-design-icon": "_material-design-icon_GGid4",
  formGroup,
  formGroup_noGap,
  formGroup__label,
  formGroup__description,
  formGroup__content,
  formGroup__content_only
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("fieldset", { class: [_vm.$style.formGroup, { [_vm.$style.formGroup_noGap]: _vm.noGap }], attrs: { "aria-describedby": _setup.getDescriptionId() } }, [_c("legend", { class: [_vm.$style.formGroup__label, { "hidden-visually": _vm.hideLabel }] }, [_vm._t("label", function() {
    return [_vm._v(" " + _vm._s(_vm.label || "⚠️ Missing label") + " ")];
  })], 2), _setup.hasDescription() ? _c("div", { class: [_vm.$style.formGroup__description, { "hidden-visually": _vm.hideDescription }], attrs: { "id": _setup.descriptionId } }, [_vm._t("description", function() {
    return [_vm._v(" " + _vm._s(_vm.description) + " ")];
  })], 2) : _vm._e(), _c("div", { class: [_vm.$style.formGroup__content, { [_vm.$style.formGroup__content_only]: _setup.hasContentOnly() }] }, [_vm._t("default")], 2)]);
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles,
  null
);
const NcFormGroup = __component__.exports;
export {
  NcFormGroup as N
};
//# sourceMappingURL=NcFormGroup-geUvdoIG.mjs.map
